import { FC } from "react";
import Box from "@mui/material/Box";
import { FilterPanel } from "../FilterPanel";
import { FilterOption } from "../types";
import { FILTERS_GROUP } from "../../constants";
import { ProductsFilter } from "../../../../../components/filters/UserFilters/ProductsFilter/ProductsFilter";

interface FiltersContentProps {
  activeFilterId: string;
  filters: FilterOption[];
}

const FILTERS = FILTERS_GROUP.flatMap((group) => {
  return group.items.map((filter) => filter);
});

export const FiltersContent: FC<FiltersContentProps> = (props) => {
  return (
    <Box sx={{ flexGrow: 1, overflow: "auto" }}>
      {FILTERS.map((filter) => (
        <FilterPanel
          key={filter.id}
          id={filter.id}
          activeFilterId={props.activeFilterId}
        >
          {filter.id === "products-filter" ? (
            <ProductsFilter height="100%" overflowY="auto" />
          ) : (
            filter.content
          )}
        </FilterPanel>
      ))}
    </Box>
  );
};
